'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _combineStyles = require('../../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = function root(myMessage, type, collapsed, fontSize, overrideStyle) {
  var style = _styles2.default.root;

  if (myMessage) {
    style = (0, _combineStyles2.default)(style, { color: _colors2.default.white });
  }

  if ((type === 'image' || type === 'giphy' || type === 'video') && !collapsed) {
    style = (0, _combineStyles2.default)(style, _styles2.default.image);
  }

  if (type === 'sticker') {
    style = (0, _combineStyles2.default)(style, { alignSelf: 'center', paddingTop: '2px' });
  }

  if (fontSize === 'medium') {
    style = (0, _combineStyles2.default)(style, { fontSize: '14px', lineHeight: '14px' });
  }

  if (fontSize === 'large') {
    style = (0, _combineStyles2.default)(style, { fontSize: '16px', lineHeight: '16px' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

exports.default = {
  root: root
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/message-time/get-styles.js
// module id = 752
// module chunks = 0